import './SquareImage.scss';
import Component from './SquareImage.js';
export default Component;
